import templateUrl from './contact-info.html';
import clone from 'lodash/clone';

export const contactInfoComponent = {
	bindings: {
		details: '<',
		parentSlug: '@'
	},

	templateUrl,

	controller: class ContactInfoComponent {
		constructor($state, toastr, CompareObjectService, ModalService, ContactInfoService) {
			'ngInject';

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.contactInfoService = ContactInfoService;
		}

		$onInit() {
			this.details = this.contactInfoService.getContactInfoObject(this.details);
			this.pageTitle = "Contact Info";
			this.savedData = angular.copy(this.details);
			this.emptyPhoneNumberDetailsObject = {
				number: '',
				extn: '',
				isFocused: false
			};
			this.disableButtons = false;
		}

		onPhoneNumberAdd() {
			this.emptyPhoneNumberDetailsObject.isFocused = true;
			this.details.phone.push(angular.copy(this.emptyPhoneNumberDetailsObject));
		}

		onPhoneNumberDelete(index) {
			const item = this.details.phone[index];
			this.details.phone.splice(index, 1);
		}

		onSubmit() {
			this.disableButtons = true;
			this.contactInfoService.editContactInfo(this.details)
				.then(_ => {
					this.toastr.success("Contact Information updated successfully.");
					this.$state.reload();
				})
				.catch(err => {
					this.disableButtons = false;
					this.toastr.error(err);
				});
		}

		onCancel() {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: 'home-banner'
			});
		}

	}
};


// WEBPACK FOOTER //
// ./src/app/components/contact-info/contact-info.component.js